





















// Composition
import { defineComponent } from '@nuxtjs/composition-api'

// Types
import { ElasticFieldsInterface } from '@/types/search/elasticTypes'

// Common
import { decodeHTMLEntities, slugify } from '@/common/utils/characters'
import { getResourceHeading } from '@/common/utils/search'

// Composables
import useSearchAnalytics from '@/composables/analytics/useSearchAnalytics'
import useSearch from '@/composables/search/useSearch'

export default defineComponent({
  name: 'ContentType',

  props: {
    fields: {
      required: true,
      type: Object as () => ElasticFieldsInterface,
    },
    id: {
      type: [Number, String],
      required: true,
    },
    score: {
      type: Number,
      required: false,
      default: 0,
    },
  },

  setup() {
    const { trackResourceClick } = useSearchAnalytics()
    const { getSearchResultUrl } = useSearch()

    const stripBrand = (fields: ElasticFieldsInterface) => {
      if (fields.title === undefined) {
        return
      }
      const title = fields?.title?.raw.replace(' | Cell Signaling Technology', '')
      return decodeHTMLEntities(title)
    }

    return {
      decodeHTMLEntities,
      slugify,
      getSearchResultUrl,
      getResourceHeading,
      stripBrand,
      trackResourceClick,
    }
  },
})
